export const ANOMALY_INTERACTION_DAYS_PRIOR = 2;
export const ANOMALY_TAG_BAR_COUNT = 8;
